import "./StartingPoints.css";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { StartingPoint } from "../../interfaces/StartingPoint.interface";
import { formatTime } from "../../utilities/helpers/formatTime";

interface StartingPointsProps {
  startingPoints: StartingPoint[];
}

const toMinutes = (time: string): number => {
  const hour = Number(time.substring(0, 2));
  const minute = Number(time.substring(3, 5));

  return hour * 60 + minute;
};

const byTime = (a: StartingPoint, b: StartingPoint) => {
  return toMinutes(a.time) - toMinutes(b.time);
};

export const StartingPoints = ({ startingPoints }: StartingPointsProps) => {
  const sortedStartingPoints = startingPoints.sort(byTime);

  return (
    <div>
      <h2>Starting Points</h2>

      <TableContainer className="startingPoints">
        <Table aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell>Name</TableCell>
              <TableCell>Description</TableCell>
              <TableCell>Address</TableCell>
              <TableCell>Time</TableCell>
              <TableCell className="noWrap">Distance (miles)</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {sortedStartingPoints.map((startingPoint) => (
              <TableRow
                key={startingPoint.id}
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                <TableCell component="th" scope="row">
                  {startingPoint.name}
                </TableCell>
                <TableCell>{startingPoint.description}</TableCell>
                <TableCell>{startingPoint.address}</TableCell>
                <TableCell className="noWrap" align="center">
                  {formatTime(startingPoint.time)}
                </TableCell>
                <TableCell align="center">{startingPoint.miles}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};
